const HOST = process.env.VITE_REST_API_HOST;

const GET_PAYMENT_DETAIL = {
  method: 'GET',
  path: `${HOST}go_shared/payment/payment`
};
const MAKE_PROJECT_PAYMENT = {
  method: 'POST',
  path: `${HOST}go_shared/payment/project`
};
const MAKE_PARTICIPANT_PAYMENT = {
  method: 'POST',
  path: `${HOST}go_shared/payment/participant`
};
const MAKE_TRIP_PAYMENT = {
  method: 'POST',
  path: `${HOST}go_shared/payment/trip`
};
const MAKE_TRAVEL_PAYMENT = {
  method: 'POST',
  path: `${HOST}go_shared/payment/travel`
};

export default {
  GET_PAYMENT_DETAIL,
  MAKE_PROJECT_PAYMENT,
  MAKE_PARTICIPANT_PAYMENT,
  MAKE_TRIP_PAYMENT,
  MAKE_TRAVEL_PAYMENT
};
